/**
 * Anzeigenamen der Clients, die sich per Device-Flow mit DiNo verbinden können.
 * Bewusst an einer Stelle gepflegt — sowohl die Sitzungsliste („Mein Konto") als
 * auch die Freigabe-Seite und der Verbinden-Dialog greifen darauf zu. Der
 * Schlüssel ist der Wert, den der Client im Header `X-DiNo-Client` sendet.
 */
export const PRETTY_CLIENT_NAMES: Record<string, string> = {
  web: 'DiNo Web',
  'thunderbird-plugin': 'Thunderbird-Plugin',
  'outlook-plugin': 'Outlook-Plugin',
  'word-plugin': 'Word-Plugin',
  'agent-cli': 'CLI-Tool',
  'mitarbeiter-app': 'DiNo Mitarbeiter-App',
};

/** Anzeigename eines Clients; unbekannte Schlüssel werden roh durchgereicht. */
export const prettyClientName = (raw?: string | null): string =>
  PRETTY_CLIENT_NAMES[(raw || '').toLowerCase()] || raw || 'Client';
